function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#B9C0C7",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.998 2.146a.958.958 0 00-.513.151L3 4.495H1c-.552 0-1 .47-1 1.05v4.203c0 .58.448 1.05 1 1.05h2l3.485 2.197a.958.958 0 00.513.151C7.52 13.146 8 12.71 8 12.094V3.198c0-.615-.48-1.052-1.002-1.052M6 4.967v5.358L4.066 9.106l-.488-.309H2V6.495H3.578l.488-.309L6 4.967M10 13.396h-.75v-1.5H10a4.254 4.254 0 004.25-4.25A4.254 4.254 0 0010 3.396h-.75v-1.5H10a5.756 5.756 0 015.75 5.75 5.756 5.756 0 01-5.75 5.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 10.396h-.75v-1.5H10c.689 0 1.25-.56 1.25-1.25 0-.689-.561-1.25-1.25-1.25h-.75v-1.5H10a2.752 2.752 0 012.75 2.75 2.752 2.752 0 01-2.75 2.75"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default SvgComponent;